(function ($) {
  let seize_rest = seize_data.site_url + '/wp-json/apecita/v1'

  $('.slick-row').each(function () {

    if ($(this).children('div').length > 1) {
      $(this).slick({
        centerMode: false,
        infinite: false,
        dots: false,
        prevArrow: $(this).siblings('.btn-slider').children('.btn-prev'),
        nextArrow: $(this).siblings('.btn-slider').children('.btn-next'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,

            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,

            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      })
    }
  })



  $('#share-button').on('click', function () {
    $('.seize-popup').addClass('active')
  })
  $('.modal-close').on('click', function () {
    $('.seize-popup').removeClass('active')
  })


  $('.mailjet-subscription').on('click', function (e) {

    e.preventDefault()


    var email = $('input[name="email"]').val();
    var type = $('input[name="type"]:checked').val();

    $.ajax({
      url: seize_rest + '/mailjetnewsletter',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        email: email,
        type: type
      }),
      processData: false,
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      complete: function (response) {

        if (response['responseJSON']['success'] == true) {
          $('.newsletter-inner__bottom-content').html('<div class="success-message">' + response['responseJSON']['message'] + '</div>');
          $('.newsletter-inner__right-content').html('<div class="success-message">' + response['responseJSON']['message'] + '</div>');
        } else {
          $('.newsletter-inner__right-content').html('<div class="error-message">' + response['responseJSON']['message'] + '</div>');
        }
      }

    });
  });


  let hideTimeout;

  $('.menu-item-has-children').on('mouseenter', function () {
    clearTimeout(hideTimeout);
    $(this).find('.sub-menu').addClass('active');
  }).on('mouseleave', function () {
    const $submenu = $(this).find('.sub-menu');
    hideTimeout = setTimeout(() => {
      $submenu.removeClass('active');
    }, 200); // 200ms delay
  });

  // Also handle submenu hover to cancel the hide
  $('.sub-menu').on('mouseenter', function () {
    clearTimeout(hideTimeout);
  }).on('mouseleave', function () {
    $(this).removeClass('active');
  });



  $('.accordion-toggle').click(function () {
    var $content = $(this).next('.accordion-content');

    // Optional: close other items
    $('.accordion-content').not($content).slideUp();
    $('.accordion-toggle').not(this).removeClass('active');

    // Toggle this one
    $content.slideToggle();
    $(this).toggleClass('active');
  });



  // Share on Facebook
  $('#facebook-share').on('click', function () {
    var url = window.location.href;
    var facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    window.open(facebookUrl, '_blank');
  });

  // Share on LinkedIn
  $('#linkedin-share').on('click', function () {
    var url = window.location.href;
    var linkedInUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
    window.open(linkedInUrl, '_blank');
  });

  // Share on Instagram
  $('#instagram-share').on('click', function () {
    var imageUrl = seize_data.post_image; // Replace with the URL of the image you want to share
    var postUrl = window.location.href; // The URL of your WordPress post
    var postTitle = document.title; // The title of your post

    // Create the Instagram Story share URL
    var instagramUrl = `instagram-stories://share?background_image=${encodeURIComponent(imageUrl)}&top_text=${encodeURIComponent(postTitle)}&bottom_text=${encodeURIComponent(postUrl)}`;

    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // If it's a mobile device, try to open the Instagram app
      window.location.href = instagramUrl;
    } else {
      // If not on a mobile device, alert the user
      alert('Instagram Story sharing is only available on mobile devices with the Instagram app installed.');
    }
  });


  // Share via Email
  $('#mail-share').on('click', function () {
    var subject = 'Regardez cet article : ' + seize_data.post_title;
    var body = "J'ai trouvé cet article très intéressant : " + window.location.href;
    var mailtoLink = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    window.location.href = mailtoLink;
  });




  $('#like-button').on('click', function () {
    var post_id = $(this).data('post-id');
    $.ajax({
      url: seize_rest + '/likePost',
      type: 'POST',
      data: JSON.stringify({
        post_id: post_id // Ensure this is correctly formatted as an array of objects or IDs
      }),
      processData: false,
      contentType: "application/json",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        $('#like-button span').text(response + ' j\'aime');
        $('#like-button').toggleClass('liked')
      }
    })
  })

  $('.slick-inner__question').on('click', function () {
    $(this).toggleClass('active')
  })


  if (seize_data.postId) {
    var scrollTimeout;
    var readingData = localStorage.getItem('readingPosition-' + seize_data.postId);
    if (readingData) {
      readingData = JSON.parse(readingData);

      $('html, body').animate({ scrollTop: $(document).height() * (readingData.position / 100) }, 800);
    }
    $(window).scroll(function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(saveReadingPosition, 1000);
    });
  }

  if ($('section.continue-reading').length > 0) {
    sendReadingPositionsToServer();
  }

  $('.hamburger').on('click', function () {
    $(this).toggleClass('active')
    $('.header-mobile__inner').toggleClass('active')
    $('.button-search-mobile').removeClass('active')
    $('.header-mobile__menu').removeClass('hide')
    $('.header-mobile__search').removeClass('active')
    $('body').toggleClass('menuActive')
  })

  $('.header-mobile__menu .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault()
    $(this).parent().toggleClass('active')
  })

  $('.button-search-mobile').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $('.hamburger').removeClass('active')
      $('.header-mobile__inner').removeClass('active')
      $('.header-mobile__search').removeClass('active')
      $('.header-mobile__menu').removeClass('hide')
    } else {
      $(this).addClass('active')
      $('.hamburger').addClass('active')
      $('.header-mobile__search').addClass('active')
      $('.header-mobile__inner').addClass('active')
      $('.header-mobile__menu').addClass('hide')
    }

  })

  displayPreviousSearches();

  $(document).on('submit', 'form.searchform', function (event) {

    event.preventDefault();
    var searchQuery = $(this).find('input[name="s"]').val().trim().replace(/ /g, '+');

    if (searchQuery) {
      var searches = JSON.parse(localStorage.getItem('searches')) || [];
      searches.unshift(searchQuery);
      if (searches.length > 5) {
        searches = searches.slice(0, 5);
      }
      localStorage.setItem('searches', JSON.stringify(searches));
      this.submit();
    }
  })
  let currentIndex = 10;
  const itemsPerPage = 10;
  $('#load-more').on('click', function () {
    const hiddenJobs = $('#job-list li.job-hidden');
    hiddenJobs.slice(0, itemsPerPage).removeClass('job-hidden');
    currentIndex += itemsPerPage;

    if (currentIndex >= $('#job-list li').length) {
      $('#load-more').hide();
    }
  });



  // Function to display previous searches
  function displayPreviousSearches() {
    var searches = JSON.parse(localStorage.getItem('searches')) || [];
    var searchList = $('.header-mobile__search-previous');
    searchList.empty(); // Clear previous list

    if (searches.length > 0) {
      var list = $('<ul></ul>');
      searches.forEach(function (search) {
        list.append('<li><a href="' + seize_data.site_url + '?s=' + search + '">' + search + '</a></li>');
      });
      searchList.append(list);
    }
  }

  // Display previous searches on page load


  function sendReadingPositionsToServer() {
    // Collect all reading positions stored in local storage
    var storedPosts = [];
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key.startsWith('readingPosition-')) {
        var item = localStorage.getItem(key);
        if (item) {
          var data = JSON.parse(item);
          storedPosts.push({
            postId: data.postId,
            position: data.position // Now also sending the scroll position percentage
          });
        }
      }
    }

    // Check if there are any posts to send
    if (storedPosts.length > 0) {
      $.ajax({
        url: seize_rest + '/continueReading',
        type: 'POST',
        data: JSON.stringify({
          storedPosts: storedPosts // Ensure this is correctly formatted as an array of objects or IDs
        }),
        type: "POST",
        processData: false,
        contentType: "application/json",
        cache: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          $('.continue-reading').removeClass('inactive')
          // Success callback function - handle the response

          $('.slick-row__reading').html(response)

          $('.slick-row__reading').slick({
            centerMode: false,
            infinite: false,
            dots: false,
            prevArrow: $(this).siblings('.btn-slider').children('.btn-prev'),
            nextArrow: $(this).siblings('.btn-slider').children('.btn-next'),
            responsive: [

              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,

                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          })

          // Optionally update the DOM here based on the response
        },
        error: function (xhr, status, error) {
          // Error handling
          console.error('AJAX Error:', status, error);
        }
      });
    } else {

    }
  }
  function saveReadingPosition() {
    // Get the current scroll position from the top of the document
    var scrollTop = $(window).scrollTop();

    // Calculate the total document height minus the window height, which is the total scrollable area
    var scrollHeight = $(document).height() - $(window).height();


    // Ensure that scrollHeight is more than 0 to avoid division by zero
    var scrollPercentage = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;

    // Round the scroll percentage to two decimal places
    scrollPercentage = Math.round(scrollPercentage * 100) / 100;

    // Assuming you have access to the WordPress post ID in some way, such as an HTML data attribute
    var postID = seize_data.postId; // Ensure the post ID is stored in a data-id attribute on an element

    if (scrollPercentage > 90) {
      localStorage.removeItem('readingPosition-' + postID);
    } else {
      // Create an object to store both the post ID and the scroll position
      var readingData = {
        position: scrollPercentage,
        postId: postID
      };

      // Save this object to local storage, keying it with the post ID to differentiate between posts
      localStorage.setItem('readingPosition-' + postID, JSON.stringify(readingData));
    }
  }

  $('.filiere-tab__li').on('click', function () {
    $('.filiere-tab__li').removeClass('active');
    $(this).addClass('active');
    let attr = $(this).attr('data-tab');
    $('.post-content__inner').addClass('inactive');
    $('.post-content__inner[data-content="' + attr + '"').removeClass('inactive');
  })

  $('.post-type__filter ul li').on('click', function () {
    let filterSearch = $(this).attr('data-search')
    $('html, body').animate({
      scrollTop: ($('.col-12[data-searchpost="' + filterSearch + '"').offset().top - 100)
    }, 500);

  })




})(jQuery);